<template>
    <div class="number-input-spinner">
      <button @click="decrement" type="button">-</button>
      <input type="number" :value="value" @input="updateValue($event.target.value)" />
      <button @click="increment"  type="button">+</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NumberInputSpinner',
    props: {
      value: {
        type: Number,
        default: 0
      },
      min: {
        type: Number,
        default: -Infinity
      },
      max: {
        type: Number,
        default: Infinity
      },
      step: {
        type: Number,
        default: 1
      }
    },
    methods: {
      increment() {
        if (this.value < this.max) {
          this.$emit('input', this.value + this.step);
        }
      },
      decrement() {
        if (this.value > this.min) {
          this.$emit('input', this.value - this.step);
        }
      },
      updateValue(value) {
        const numericValue = Number(value);
        if (numericValue >= this.min && numericValue <= this.max) {
          this.$emit('input', numericValue);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .number-input-spinner {
    display: flex;
    align-items: center;
  }
  .number-input-spinner button {
    -webkit-appearance: none;
    transition: background 0.5s ease;
    background: #556ee6;
    border: 0;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;

    &:hover {
      background: lighten(#556ee6, 10%);
    }

    &:focus {
      outline: 1px dashed lighten(#556ee6, 20%);
      outline-offset: -5px;
    }

  }
  .number-input-spinner input {
    -webkit-appearance: none;
    border: 1px solid #ebebeb;
    float: left;
    font-size: 16px;
    height: 40px;
    margin: 0;
    outline: none;
    text-align: center;
    width: calc(100% - 80px);

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
  </style>